var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "requestManager",
      staticClass: "request-manager",
      class: {
        hide: Object.values(_vm.requests).length == 0,
        open: _vm.isOpen,
      },
      on: { click: _vm.open },
    },
    [
      _c("header", { ref: "header" }, [
        _c("h4", [_vm._v(_vm._s(_vm.textHeader))]),
        _c("div", { staticClass: "square" }, [
          _c("i", { staticClass: "fa-regular fa-paper-plane" }),
          _c("div", { ref: "progressCircle", staticClass: "progress-circle" }),
        ]),
      ]),
      _c("div", { staticClass: "container-list-request hide-scrollbar" }, [
        _c(
          "div",
          { ref: "listRequest", staticClass: "list-request" },
          _vm._l(Object.values(_vm.requests), function (request) {
            return _c("div", { key: request.id, staticClass: "item" }, [
              _c("div", { staticClass: "picture" }, [
                _c("img", {
                  attrs: {
                    src: request.picture ? request.picture : "img/avatar.jpg",
                  },
                }),
              ]),
              _c("div", { staticClass: "column" }, [
                _c("p", {
                  staticClass: "title",
                  domProps: {
                    innerHTML: _vm._s(request.title ? request.title : ""),
                  },
                }),
                request.status == "success"
                  ? _c("p", { staticClass: "success" }, [
                      _c("i", { staticClass: "fa-regular fa-circle-check" }),
                      _c("span", [
                        _vm._v(_vm._s(request.successText || "Envoyé !")),
                      ]),
                    ])
                  : _vm._e(),
                request.status == "error"
                  ? _c("p", {
                      staticClass: "error",
                      domProps: {
                        innerHTML: _vm._s(
                          `<i class='fa-regular fa-circle-exclamation'></i>${
                            request.errorText || "Echec !"
                          }`
                        ),
                      },
                    })
                  : _vm._e(),
                request.status == "loading"
                  ? _c("div", { staticClass: "container-progress" }, [
                      _c("div", { staticClass: "bar" }, [
                        request.progressPct != null
                          ? _c("div", {
                              staticClass: "progress",
                              style: { width: request.progressPct + "%" },
                            })
                          : _c("div", { staticClass: "progress infinite" }),
                      ]),
                      _c("p", [
                        _vm._v(
                          _vm._s(request.loadingText ? request.loadingText : "")
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              request.status == "success" && request.onAction
                ? _c(
                    "button",
                    {
                      staticClass: "action-btn",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.triggerAction(request.id)
                        },
                      },
                    },
                    [_vm._v("Afficher →")]
                  )
                : _vm._e(),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }